import LandingPageHeroChiclet from '@/app/components/LandingPage/LandingPageHero/LandingPageHeroChiclet';

export function PopHeroChiclet(): JSX.Element {
  return (
    <LandingPageHeroChiclet
      cta={{
        href: '/product/rings/oura-gen3/heritage',
        label: 'pop_hero_lower_price_chiclet_cta',
      }}
      data-cy="pop_hero_chiclet"
      image={{
        localizedAlt: 'explore_image_alt_4',
        src: 'blue-sky/pop/pop-gen3-chiclet.jpg?ar=3:4&fit=crop&crop=focalpoint&fp-x=0.5fp-z=1',
      }}
      motionProps={{
        transition: { duration: 2, type: 'tween', delay: 1.25 },
      }}
      title="pop_hero_lower_price_chiclet_title"
    />
  );
}
